import { EPSL_AUDITS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/epsl_audits_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['epslAuditsIndex']);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
